const axios = require('axios').default;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;

const decipherErrors = error => {
  const response = error.response.data;

  if(response.errors) {
    return Object.keys(response.errors)
      .reduce((carry, field) => [...carry, ...response.errors[field]], []);
  }

  return [
    response.message || 'An unknown error occurred.',
  ];
};


const state = () => ({
  filterKeyword: '',
  itemListErrors: [],
  itemLists: [],
  savingItemList: false,
  savingToItemList: false,
  showItemListCreate: false,
});

const getters = {
  filteredItemLists: state => {
    if(!state.filterKeyword) {
      return state.itemLists;
    }

    return state.itemLists
      .filter(list => list.name.match(new RegExp(state.filterKeyword, 'gi')));
  },

  showItemListSelect: (state, getters) => {
    return state.itemLists.length > 0
      && !state.showItemListCreate
      && !getters.showItemListAdded;
  },
};

const mutations = {
  updateFilterKeyword(state, word) {
    state.filterKeyword = word;
  },

  updateItemListErrors(state, errors) {
    state.itemListErrors = errors;
  },

  updateItemLists(state, lists) {
    state.itemLists = lists;
  },

  updateItemListCreateDisplay(state, boolValue) {
    state.showItemListCreate = boolValue;
  },

  updateSavingItemList(state, boolValue) {
    state.savingItemList = boolValue;
  },

  updateSavingToItemList(state, boolValue) {
    state.savingToItemList = boolValue;
  },
};

const actions = {
  clearItemListErrors({ commit }) {
    commit('updateItemListErrors', []);
  },

  async createItemList({ commit, dispatch, state }, newItemList) {
    dispatch('clearItemListErrors');
    commit('updateSavingItemList', true);

    await axios.post('/account/item-lists', newItemList)
      .then(response => {
        let lists = [...state.itemLists, ...[response.data.list]];

        commit('updateItemLists', lists);
        commit('updateItemListCreateDisplay', false);
      })
      .catch(error => {
        let errors = decipherErrors(error);

        commit('updateItemListErrors', errors);
      })
      .finally(() => commit('updateSavingItemList', false));
  },

  async saveToItemList({ commit, dispatch, state }, { list, sku }) {
    dispatch('clearItemListErrors');
    commit('updateSavingToItemList', true);

    await axios.post(`/account/item-lists/${list}/${sku}`)
      .then(response => {
        let lists = [...state.itemLists];

        const index = lists.findIndex(itemList => itemList.identifier === list);

        lists[index] = {
          ...lists[index],
          ...{
            items: [
              ...lists[index].items || [],
              response.data,
            ],
            item_count: lists[index].item_count + 1
          },
        };

        commit('updateItemLists', lists);
      })
      .catch(error => {
        let errors = decipherErrors(error);

        commit('updateItemListErrors', errors);
      })
      .finally(() => commit('updateSavingToItemList', false));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
